import { render } from "./ECommerce.vue?vue&type=template&id=38305e62&scoped=true"
import script from "./ECommerce.vue?vue&type=script&lang=js"
export * from "./ECommerce.vue?vue&type=script&lang=js"

import "./ECommerce.vue?vue&type=style&index=0&id=38305e62&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38305e62"]])

export default __exports__